var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalysisManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.662 13.249h12.414a.83.83 0 01.828.827.83.83 0 01-.828.828H.835a.83.83 0 01-.828-.828V.835A.83.83 0 01.835.007a.83.83 0 01.827.828v12.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.766 9.69a.838.838 0 01-1.159.041.838.838 0 01-.041-1.158l3.103-3.31c.29-.332.787-.332 1.159-.083l2.441 2.11 3.187-4.055c.29-.373.786-.414 1.158-.124.373.29.414.786.124 1.158l-3.724 4.718c-.29.372-.827.413-1.2.124L7.331 6.959 4.766 9.69z"
  }))));
}

export default SvgAnalysisManage;